import { JSX } from 'react'

import { IconProps } from '../../icon'

const Copy: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M36.2214 8H16.7143C14.6376 8 12.9482 9.69452 12.9482 11.7775V12.947H11.7661C9.68944 12.947 8 14.6416 8 16.7257V36.2215C8 38.3044 9.68944 39.999 11.7661 39.999H31.2737C33.3572 39.999 35.0518 38.3044 35.0518 36.2215V35.0519H36.2214C38.3048 35.0519 40 33.3574 40 31.2733V11.7774C39.9999 9.69452 38.3048 8 36.2214 8ZM32.7397 36.2214C32.7397 37.0297 32.0822 37.6868 31.2737 37.6868H11.7661C10.9645 37.6868 10.3121 37.0297 10.3121 36.2214V16.7256C10.3121 15.9173 10.9647 15.259 11.7661 15.259H14.1042H31.2737C32.082 15.259 32.7397 15.9171 32.7397 16.7256V33.8956V36.2214ZM37.6878 31.2732C37.6878 32.0815 37.0302 32.7397 36.2212 32.7397H35.0517V16.7256C35.0517 14.6416 33.3572 12.9469 31.2736 12.9469H15.2602V11.7774C15.2602 10.9691 15.9127 10.312 16.7142 10.312H36.2212C37.0301 10.312 37.6878 10.9691 37.6878 11.7774V31.2732Z'
      fill='black'
    />
  </svg>
)

export default Copy
